module.exports = __webpack_public_path__ + "img/industry4_active.bbc15bac.png";